const STEP_STATUS = {
    COMPLETED: 'completed',
    UPCOMING: 'upcoming',
    ACTIVE: 'active',
    COMPLETEDINACTIVE: 'completedInActive'
};

export default (livewireComponent) => ({
    activeStep: livewireComponent.entangle('activeStep').live,
    steps: livewireComponent.entangle('steps').live,
    previousValue: null,
    selectedSource: livewireComponent.entangle('selectedSource').live,
    validationInProgress: false,

    updateContentMaxHeight: function () {
        let stepper = document.querySelector(`[stepper-fit-screen]`);
        if(!stepper) return;
        let content = stepper.querySelector(`[data-section='content']`);
        const rect = content.getBoundingClientRect();
        const distanceFromTop = rect.top;
        let maxHeight = `calc(100vh - 6.5rem - ${distanceFromTop}px)`;
        document.documentElement.style.setProperty('--stepper-content-max-height', maxHeight);
    },

    fitScreen: function(){
        let shouldFit = this.$el.hasAttribute('stepper-fit-screen');
        if (shouldFit) {
            this.updateContentMaxHeight();
            window.addEventListener('resize', this.updateContentMaxHeight);
        }
    },

    init() {
        const splitHash = window.location.hash.slice(1).split("/");
        const initialStep = splitHash[0];
        if(!this.activeStep){
            this.activeStep = this.steps.indexOf(initialStep) > -1 ? initialStep : this.steps[0].name;
        } else {
            this.updateStepStatuses();
        }

        if (window.Livewire) {
            window.Livewire.on("validationPassed", () => {
                setTimeout(() => {
                    if (!this.validationInProgress) {
                        this.goToNextStep();
                    }
                }, 500); 
            });
        }

        this.fitScreen();

        this.$watch('steps', (newSteps,oldSteps) => {
            const isActiveStepFound = Object.values(this.steps).some((step) => step.name === this.activeStep);
            if(!isActiveStepFound ){
                this.goToNextStep(oldSteps)
                this.updateStepStatuses()
            }
        })
    },

    setActiveStep(step) {
        this.activeStep = step;
    },

    resetSteps() {
        const splitHash = window.location.hash.slice(1).split("/");
        const initialStep = splitHash[0];
        this.activeStep =
            this.steps.indexOf(initialStep) > -1 ? initialStep : this.steps[0].name;

        this.steps.forEach(step => {
            step.status = STEP_STATUS.UPCOMING;
        });
    },

    goToPreviousStep() {
        const currentIndex = this.steps.findIndex(step => step.name === this.activeStep);
        if (currentIndex > 0) {
            this.activeStep = this.steps[currentIndex - 1].name;
        }
    },

    validateOnNext() {

        this.validationInProgress = true;
        livewireComponent.call('validateStep', this.activeStep).then(() => {

            this.validationInProgress = false;
        }).catch(() => {
            this.validationInProgress = false;
        });
    },

    goToNextStep(steps = null){
        if(!steps){
            steps = this.steps;
        }
        const currentIndex = steps.findIndex((step) => step.name === this.activeStep);
        if (currentIndex < steps.length - 1) {

            this.activeStep = steps[currentIndex + 1].name;
            steps[currentIndex].status = STEP_STATUS.COMPLETED;
        }else if (currentIndex === steps.length - 1) {
            livewireComponent.call('save');
        }
    },

    moveToStep(selectedIndex) {

        const selectedStep = this.steps[selectedIndex];
        if (this.validationInProgress) {
            return;
        }
        // Prevent moving if the previous step is in UPCOMING status
        if (selectedIndex > 0 && this.steps[selectedIndex - 1].status === STEP_STATUS.UPCOMING ) {
            this.validateOnNext();
            return;
        }
        if (selectedStep.status === STEP_STATUS.ACTIVE || selectedStep.status === STEP_STATUS.COMPLETED 
            ||(selectedIndex > 0 && ( this.steps[selectedIndex - 1].status === STEP_STATUS.COMPLETED 
            || this.steps[selectedIndex - 1].status === STEP_STATUS.COMPLETEDINACTIVE))) {
                
            this.activeStep = selectedStep.name;
            this.updateStepStatuses();
            return;
        }

        if (selectedIndex > 0 && ( this.steps[selectedIndex - 1].status === STEP_STATUS.ACTIVE || this.steps[selectedIndex - 1].status === STEP_STATUS.COMPLETEDINACTIVE ) ) {
            this.validateOnNext();
            this.updateStepStatuses();
            return;
        }
    },    

    updateStepStatuses() {
        const currentIndex = this.steps.findIndex(step => step.name === this.activeStep);
        this.steps.forEach((step, index) => {
            if (index < currentIndex) {
                step.status = STEP_STATUS.COMPLETED;
            } else if (index === currentIndex) {
                step.status = STEP_STATUS.ACTIVE;
            } else if (step.status !== STEP_STATUS.COMPLETED && step.status !== STEP_STATUS.ACTIVE && step.status !== STEP_STATUS.COMPLETEDINACTIVE) {
                step.status = STEP_STATUS.UPCOMING;
            }else if (step.status === STEP_STATUS.COMPLETED && step.status !== STEP_STATUS.ACTIVE){
                step.status = STEP_STATUS.COMPLETEDINACTIVE;
            }
        });
    },

    validateAndNextStep() {
        this.updateStepStatuses();
        this.validateOnNext();
    },

    validateSourceAndNextStep(value) {
        const currentValue = value.name;
        if (this.previousValue == null || this.previousValue !== currentValue) {
            this.resetSteps();
            this.previousValue = currentValue;
        }
        this.updateStepStatuses();
        setTimeout(() => {
            this.validateOnNext();
        }, 500);
    },
});
